// src/assets/icons/CustomIconsAdd1.js

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

// --- SIDEBAR GROUP ---

export const MenuSidebarMarkerColor = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(50, 50) scale(0.8) translate(-50, -50)'>
      <path
        d='M 50,28 C 38,28 28,38 28,50 C 28,68 50,90 50,90 C 50,90 72,68 72,50 C 72,38 62,28 50,28 Z'
        fill='#f44336'
      />
      <circle cx='50' cy='50' r='8' fill='#ffffff' />
    </g>
  </SvgIcon>
);

export const MenuSidebarMarkerGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(50, 50) scale(0.8) translate(-50, -50)'>
      <path
        d='M 50,28 C 38,28 28,38 28,50 C 28,68 50,90 50,90 C 50,90 72,68 72,50 C 72,38 62,28 50,28 Z'
        fill='#757575'
      />
      <circle cx='50' cy='50' r='8' fill='#ffffff' />
    </g>
  </SvgIcon>
);

export const MenuGeneralInfoColor = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <circle cx='50' cy='50' r='22' fill='#ff9800' />
    {/* Adjust x and y below to center the 'i' */}
    <text
      x='50'
      y='58'
      fontFamily='Arial'
      fontSize='30px'
      fontWeight='bold'
      fill='#ffffff'
      textAnchor='middle'>
      i
    </text>
  </SvgIcon>
);

export const MenuGeneralInfoGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <circle cx='50' cy='50' r='22' fill='#757575' />
    {/* Adjust x and y below to center the 'i' */}
    <text
      x='50'
      y='58'
      fontFamily='Arial'
      fontSize='28px'
      fontWeight='bold'
      fill='#ffffff'
      textAnchor='middle'>
      i
    </text>
  </SvgIcon>
);

export const MenuPhotosColor = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <circle cx='50' cy='50' r='22' fill='#e91e63' />
    <rect x='38' y='42' width='24' height='18' rx='2' fill='#ffffff' />
    <circle cx='44' cy='48' r='2.5' fill='#e91e63' />
    <path d='m 38,56 6,-6 6,6 6,-8 6,8 z' fill='#e91e63' />
  </SvgIcon>
);

export const MenuDocsColor = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <circle cx='50' cy='50' r='22' fill='#4caf50' />
    <path d='M 40,38 V 62 H 60 V 45 l -7,-7 z' fill='#ffffff' />
    <path d='m 53,38 v 7 h 7' fill='#4caf50' />
    <line x1='44' y1='50' x2='56' y2='50' stroke='#4caf50' strokeWidth='1.5' />
    <line x1='44' y1='54' x2='56' y2='54' stroke='#4caf50' strokeWidth='1.5' />
    <line x1='44' y1='58' x2='52' y2='58' stroke='#4caf50' strokeWidth='1.5' />
  </SvgIcon>
);

export const MenuPhotosGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <circle cx='50' cy='50' r='22' fill='#757575' />
    <rect x='38' y='42' width='24' height='18' rx='2' fill='#ffffff' />
    <circle cx='44' cy='48' r='2.5' fill='#757575' />
    <path d='m 38,56 6,-6 6,6 6,-8 6,8 z' fill='#757575' />
  </SvgIcon>
);

export const MenuDocsGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <circle cx='50' cy='50' r='22' fill='#757575' />
    <path d='M 40,38 V 62 H 60 V 45 l -7,-7 z' fill='#ffffff' />
    <path d='m 53,38 v 7 h 7' fill='#757575' />
    <line x1='44' y1='50' x2='56' y2='50' stroke='#757575' strokeWidth='1.5' />
    <line x1='44' y1='54' x2='56' y2='54' stroke='#757575' strokeWidth='1.5' />
    <line x1='44' y1='58' x2='52' y2='58' stroke='#757575' strokeWidth='1.5' />
  </SvgIcon>
);

export const MenuClose = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 0)'>
      <circle cx='25' cy='60' r='22' fill='#9e9e9e' />
      <path
        d='M 17,52 33,68 M 33,52 17,68'
        stroke='#ffffff'
        strokeWidth='3'
        strokeLinecap='round'
      />
    </g>
  </SvgIcon>
);

export const MenuFilter = (props) => (
  <SvgIcon {...props} viewBox='0 0 200 170'>
    <line
      x1='10'
      y1='30'
      x2='190'
      y2='30'
      stroke='black'
      strokeWidth='12'
      strokeLinecap='round'
    />
    <circle cx='60' cy='30' r='20' fill='#9BC8F1' stroke='black' strokeWidth='10' />
    <line
      x1='10'
      y1='85'
      x2='190'
      y2='85'
      stroke='black'
      strokeWidth='12'
      strokeLinecap='round'
    />
    <circle cx='140' cy='85' r='20' fill='#9BC8F1' stroke='black' strokeWidth='10' />
    <line
      x1='10'
      y1='140'
      x2='190'
      y2='140'
      stroke='black'
      strokeWidth='12'
      strokeLinecap='round'
    />
    <circle cx='80' cy='140' r='20' fill='#9BC8F1' stroke='black' strokeWidth='10' />
  </SvgIcon>
);

// --- INDICATORS ---

export const SmallSaveIcon = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 100'>
    <g transform='translate(0, -10)'>
      {' '}
      {/* Shift up slightly to center in the square */}
      <circle cx='50' cy='60' r='35' fill='#ff9800' />
      <path
        d='m 36,60 10,10 20,-20'
        stroke='#ffffff'
        strokeWidth='6'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </SvgIcon>
);

// --- NEW GOOGLE MAP SEARCH ICON ---

export const GoogleMapSearch = (props) => (
  <SvgIcon {...props} viewBox='0 0 6.35 6.35'>
    <g fill='none' stroke='#000'>
      <rect
        x='.26492'
        y='.87834'
        width='5.3926'
        height='5.228'
        rx='.6406'
        ry='.50294'
        strokeWidth='.26458'
      />
      <path d='m0.32163 5.562 4.8651-4.6832' strokeWidth='.26687' />
      <path d='m0.71892 6.0604 4.8929-4.71' strokeWidth='.2684' />
      <path
        d='m5.6191 5.4665c-2.0338-2.1128-2.0338-2.1128-2.0338-2.1128'
        strokeWidth='.26458'
      />
      <path
        d='m5.1626 6.0196c-2.0338-2.1128-2.0338-2.1128-2.0338-2.1128'
        strokeWidth='.26458'
      />
    </g>
    <g transform='matrix(.3571 0 0 .3571 3.0202 .30682)'>
      <circle
        cx='4.9526'
        cy='3.5819'
        r='3.4525'
        fill='#fff'
        stroke='#000'
        strokeWidth='.2'
      />
      <path
        d='m2.1746 5.6058c0.07722 0.19674 2.7336 3.7682 2.7336 3.7682l2.8417-3.7531'
        fill='#fff'
        stroke='#000'
        strokeWidth='.19964'
      />
      <circle cx='4.9527' cy='3.5629' r='3.1528' fill='#f32127' strokeWidth='.14331' />
      <circle cx='4.8831' cy='3.5812' r='1.5571' strokeWidth='.070782' />
    </g>
    <g stroke='#000'>
      <g strokeWidth='.052692'>
        <path
          transform='scale(.26458)'
          d='m1.5281 12.507v-7.4809l0.13369-0.26829c0.15715-0.31537 0.48982-0.59397 0.91426-0.76566l0.29569-0.11962 5.4465-0.014368c5.196-0.013707 5.4448-0.010072 5.4087 0.079038-0.53929 1.3324-0.59003 2.5406-0.1548 3.6864 0.07497 0.19737 0.14814 0.40773 0.1626 0.46747 0.02143 0.088486-0.98267 1.0793-5.4184 5.3469-2.9946 2.8811-5.747 5.5334-6.1165 5.8941l-0.67182 0.65573z'
          fill='#00bf19'
        />
        <path
          transform='scale(.26458)'
          d='m3.8992 22.534c0-0.02661 7.54-7.2779 7.5858-7.2953 0.03137-0.01193 5.579 5.7118 6.7942 7.0099l0.28363 0.30298h-7.3318c-4.0325 0-7.3318-0.0079-7.3318-0.01762z'
          fill='#00a6ea'
        />
        <path
          transform='scale(.26458)'
          d='m17.546 16.056c-1.8113-1.8824-3.2932-3.4412-3.2932-3.464 0-0.02284 0.34825-0.3765 0.7739-0.78591l0.7739-0.74439 0.30267 0.41003c0.16647 0.22552 0.63362 0.86054 1.0381 1.4112 0.4045 0.55063 0.77531 1.0436 0.82402 1.0956 0.08399 0.08955 0.16046-7.01e-4 1.4812-1.7482l1.3927-1.8426 0.01373 2.2922c0.0076 1.2607 0.0076 3.3061 0 4.5454l-0.01373 2.2532z'
          fill='#ccc'
        />
      </g>
      <path
        transform='scale(.26458)'
        d='m2.2552 22.262c-0.10885-0.061926-0.2708-0.18549-0.35989-0.27458-0.19718-0.19718-0.36335-0.49468-0.3172-0.56791 0.017188-0.027272 2.9067-2.8174 6.4212-6.2003 6.1583-5.9277 6.3916-6.1482 6.4349-6.0836 0.02475 0.036913 0.19734 0.28069 0.38351 0.54172 0.18618 0.26103 0.3384 0.48603 0.33827 0.5-3.3e-4 0.03469-12.62 12.18-12.666 12.189-0.020104 0.0043-0.12561-0.04291-0.23446-0.10483z'
        fill='#faff46'
        strokeWidth='.03125'
      />
    </g>
  </SvgIcon>
);

// --- NEW INITIAL VIEW ICON ---

export const MenuInitialView = (props) => (
  <SvgIcon {...props} viewBox='0 0 6.35 6.35'>
    <g fill='none' stroke='#000'>
      <rect
        x='.26492'
        y='.87834'
        width='5.3926'
        height='5.228'
        rx='.6406'
        ry='.50294'
        strokeWidth='.18521'
      />
      <path d='m0.32163 5.562 4.8651-4.6832' strokeWidth='.26687' />
      <path d='m0.71892 6.0604 4.8929-4.71' strokeWidth='.2684' />
      <path d='m5.6191 5.4665-2.0338-2.1128' strokeWidth='.26458' />
      <path d='m5.1626 6.0196-2.0338-2.1128' strokeWidth='.26458' />
    </g>
    <circle
      cx='4.7888'
      cy='1.5859'
      r='1.2329'
      fill='#fff'
      stroke='#000'
      strokeWidth='.07142'
    />
    <path
      d='m3.7967 2.3087c0.027575 0.070256 0.97617 1.3456 0.97617 1.3456l1.0148-1.3402'
      fill='#fff'
      stroke='#000'
      strokeWidth='.071291'
    />
    <circle cx='4.7888' cy='1.5791' r='1.1259' fill='#21d6f3' strokeWidth='.051176' />
    <circle cx='4.764' cy='1.5857' r='.55604' strokeWidth='.025276' />
    <g fill='#ccc'>
      <g stroke='#ff7910' strokeWidth='.016126'>
        <path
          transform='scale(.26458)'
          d='m1.5233 12.469 0.0098342-7.5099 0.099982-0.18935c0.13527-0.25618 0.47242-0.56622 0.76421-0.70277 0.49555-0.2319 0.26038-0.22322 6.0732-0.22394l5.3097-6.573e-4 -0.06226 0.14196c-0.12655 0.28855-0.27684 0.75668-0.34332 1.0694-0.09516 0.44761-0.0933 1.4422 0.0035 1.8927 0.07152 0.3328 0.24712 0.86632 0.3613 1.0978l0.06536 0.13249-6.0344 5.8107c-3.3189 3.1959-6.0845 5.8514-6.1457 5.901l-0.11129 0.09031z'
        />
        <path
          transform='scale(.26458)'
          d='m17.519 16.048-3.3203-3.442 1.6046-1.562 0.11342 0.15638c0.41556 0.57294 2.0445 2.7774 2.0819 2.8175 0.03673 0.03937 0.32478-0.31909 1.4433-1.796l1.3974-1.8452 0.0098 2.2787c0.0054 1.2533 0.0054 3.3038 0 4.5566l-0.0098 2.2779z'
        />
        <path
          transform='scale(.26458)'
          d='m7.6658 18.88c2.0924-2.0144 3.8186-3.6625 3.8359-3.6625 0.03299 0 7.0472 7.271 7.0472 7.3052 0 0.01084-3.3047 0.0197-7.3438 0.0197h-7.3438z'
        />
      </g>
      <path
        transform='scale(.26458)'
        d='m1.5521 12.426v-7.4768l0.15681-0.23482c0.31375-0.46985 0.77635-0.73665 1.3788-0.79523 0.22039-0.021428 2.5035-0.036966 5.5158-0.037538l5.1398-9.766e-4 -0.05328 0.1041c-0.10646 0.20801-0.32201 0.94454-0.36695 1.2539-0.02984 0.20543-0.0387 0.54514-0.02516 0.9653 0.02282 0.70802 0.0926 1.0498 0.34111 1.6704l0.12126 0.30284-1.5904 1.5331c-4.5971 4.4314-10.152 9.769-10.438 10.029l-0.17981 0.16365z'
      />
      <path
        transform='scale(.26458)'
        d='m17.521 16.007-3.2807-3.4014 0.75918-0.73817c0.41755-0.40599 0.77137-0.74303 0.78628-0.74897 0.01491-0.0059 0.41988 0.52214 0.89995 1.1735 0.48006 0.65137 0.96375 1.3072 1.0749 1.4575 0.11111 0.15024 0.22805 0.27374 0.25987 0.27445 0.07154 0.0016 0.44851-0.46959 1.7592-2.1989l1.022-1.3485 0.0098 2.2286c0.0054 1.2257 0.0054 3.2354 0 4.4659l-0.0098 2.2374z'
      />
      <path
        transform='scale(.26458)'
        d='m3.9748 22.49c0-0.02722 7.1931-6.9377 7.4132-7.1219l0.12616-0.1056 0.25661 0.26152c0.97522 0.99391 6.2478 6.4695 6.5488 6.801l0.16329 0.17981h-7.254c-3.9897 0-7.254-0.0066-7.254-0.01474z'
      />
    </g>
  </SvgIcon>
);
